import adminDataProvider from './adminDataProvider'
import assetCustomFieldDataProvider from './assetCustomFieldDataProvider'
import assetStatusDataProvider from './assetStatusDataProvider'
import assetTypeDataProvider from './assetTypeDataProvider'
import brandingDataProvider from './brandingDataProvider'
import goroundDataProvider from './goroundDataProvider'
import prioritiesDataProvider from './prioritiesDataProvider'

const dataProvider = (type, resource, params) => {
  if (resource === 'categories') {
    return goroundDataProvider(type, resource, params)
  }
  if (resource === 'priorities') {
    return prioritiesDataProvider(type, resource, params)
  }
  if (resource === 'branding') {
    return brandingDataProvider(type, resource, params)
  }
  if (resource === 'asset-types') {
    return assetTypeDataProvider(type, resource, params)
  }
  if (resource === 'asset-statuses') {
    return assetStatusDataProvider(type, resource, params)
  }
  if (resource === 'asset-custom-fields') {
    return assetCustomFieldDataProvider(type, resource, params)
  }

  return adminDataProvider(type, resource, params)
}

export default dataProvider
